export default __webpack_public_path__ + "static/media/chevron-right-blank.f38ffee6.svg";